import Api from 'libs/api';
import AuthService from 'services/Auth';

class RestaurantServicesApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/services`);
  }

  getPossibleServices = () => {
    return this.buildQuery('get', {}, 'possible_services');
  };

  createPossibleServices = (params) => {
    return this.buildQuery('post', params, 'create_possible_services');
  };
}

export default RestaurantServicesApi;
